module.exports = __webpack_public_path__ + "img/shuab-gamote.9b02dee1.jpg";